export * from "./mapIsInFavorites";